var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: _vm.title,
        width: "696px",
        loading: _vm.loading,
        "show-close": false,
        height: "auto",
        "append-to-body": true,
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "copyLiveRoom overflowOuto",
        },
        [
          _c("div", { staticClass: "copyLiveRoomTitle" }, [
            _vm._v(
              " " +
                _vm._s(
                  { 1: "正在复制中", 2: "复制完成", 3: "复制失败" }[
                    _vm.copyLive.status
                  ]
                ) +
                " "
            ),
          ]),
          _vm.copyLive.status === 0
            ? [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      "label-position": "left",
                      model: _vm.form,
                      "label-width": "92px",
                      size: "small",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _vm.form.liveModel === "PERSON_LIVE"
                      ? _c("el-form-item", { attrs: { label: "真人讲师" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("renderTearch")(
                                  _vm.form.realityTeacherUser
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm.form.liveModel === "AI_LIVE"
                      ? _c("el-form-item", { attrs: { label: "视频讲师" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.form.recordingTeacherName) + " "
                          ),
                        ])
                      : _vm._e(),
                    _c("el-form-item", { attrs: { label: "创建人" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.form.createUserName))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "直播类型" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "liveMode",
                          class: `liveMode${_vm.form.liveModel}`,
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "liveModeicon",
                                  "icon-class": _vm.getOptionsValueByKey(
                                    "value",
                                    "icon",
                                    _vm.form.liveModel,
                                    _vm.liveModeOption
                                  ),
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("getOptionsValue")(
                                      _vm.form.liveModel,
                                      _vm.liveModeOption
                                    )
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _vm.form.liveModel === "PERSON_LIVE"
                      ? void 0
                      : _vm.form.liveModel === "AI_LIVE"
                      ? [
                          _c("el-form-item", { attrs: { label: "视频名称" } }, [
                            _c(
                              "span",
                              {
                                staticClass: "formValue a_link",
                                on: {
                                  click: function ($event) {
                                    return _vm.gotoVideo(_vm.form)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.form.videoName))]
                            ),
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "脚本名称" } },
                            [
                              _vm.form.scriptId
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "a_link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.gotoScript(_vm.form)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.form.scriptName) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                : [_vm._v(" 未使用脚本 ")],
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "直播间名称", prop: "name" } },
                      [
                        _c("el-input", {
                          staticClass: "el_input_p40",
                          attrs: { maxlength: "40", "show-word-limit": "" },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开播时间", prop: "startTime2" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "140px" },
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                            type: "date",
                            placeholder: "选择日期",
                          },
                          model: {
                            value: _vm.form.startTime1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startTime1", $$v)
                            },
                            expression: "form.startTime1",
                          },
                        }),
                        _c("el-autocomplete", {
                          staticClass: "m-l-10",
                          staticStyle: { width: "120px" },
                          attrs: {
                            clearable: "",
                            "fetch-suggestions": _vm.querySearch,
                            placeholder: "请输入",
                          },
                          on: {
                            blur: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleBlurPlayTime.apply(
                                null,
                                arguments
                              )
                            },
                            select: _vm.handleSelect,
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.handleBlurPlayTime.apply(
                                null,
                                arguments
                              )
                            },
                          },
                          model: {
                            value: _vm.form.startTime2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startTime2", $$v)
                            },
                            expression: "form.startTime2",
                          },
                        }),
                        _c("span", { staticClass: "formTips" }, [
                          _vm._v("至少提前5分钟设置好"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "运营助教", prop: "tutorTeacherUser" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addAssistant },
                          },
                          [
                            _vm._v(
                              " 添加助教(" +
                                _vm._s(_vm.form.tutorTeacherUser.length) +
                                "/200) "
                            ),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              class: {
                                assessBox: _vm.form.tutorTeacherUser.length > 0,
                              },
                            },
                            _vm._l(
                              _vm.form.tutorTeacherUser,
                              function (tag, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: tag.userId,
                                    staticClass: "remindPersonListView",
                                    attrs: {
                                      closable:
                                        !_vm.defaultDisabledUser.includes(
                                          tag.userId
                                        ),
                                    },
                                    on: {
                                      close: function ($event) {
                                        return _vm.delAssistant(tag, index)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(tag.nickName) + " ")]
                                )
                              }
                            ),
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "copyOption" } },
                      [
                        _c("div", [_vm._v("需要复制以下内容，请进行勾选")]),
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form.copyOption,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "copyOption", $$v)
                              },
                              expression: "form.copyOption",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "isApply" } }, [
                              _vm._v("报名设置"),
                            ]),
                            _c("el-checkbox", { attrs: { label: "isGoods" } }, [
                              _vm._v("直播带货"),
                            ]),
                            _c(
                              "el-checkbox",
                              { attrs: { label: "isCoupon" } },
                              [_vm._v("优惠券")]
                            ),
                            _c(
                              "el-checkbox",
                              { attrs: { label: "isPrizeDraw" } },
                              [_vm._v("抽奖")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "exportScriptFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.sure },
            },
            [_vm._v(" 确定 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(" 取消 ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }